import { render, staticRenderFns } from "./viewProposal.vue?vue&type=template&id=6283d32d&scoped=true&"
import script from "./viewProposal.vue?vue&type=script&lang=js&"
export * from "./viewProposal.vue?vue&type=script&lang=js&"
import style0 from "./viewProposal.vue?vue&type=style&index=0&id=6283d32d&scoped=true&lang=scss&"
import style1 from "./viewProposal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6283d32d",
  null
  
)

export default component.exports